import {VStack} from 'platform/foundation';

import {i18n} from '@dms/i18n';
import {testIds} from '@dms/routes';
import {SettingsSection, SettingsTemplate, SettingsTemplateHeader} from '@dms/settings/shared';
import {usePermissions} from '@dms/shared';

import {CopyRealCostsToExpectedSwitch} from '../../components/CopyRealCostsToExpectedSwitch/CopyRealCostsToExpectedSwitch';
import {PurchasePriceCostsForm} from './components/PurchasePriceCostsForm/PurchasePriceCostsForm';
import {PurchasePriceRules} from './components/PurchasePriceRules/PurchasePriceRules';

export function PurchasePrice() {
  const [canSetFinanceSettings] = usePermissions({permissionKeys: ['setFinanceSettings']});

  const header: SettingsTemplateHeader = {
    title: i18n.t('page.settings.purchasePrice.title'),
    alerts: canSetFinanceSettings
      ? undefined
      : [
          {
            type: 'banner',
            variant: 'info',
            message: i18n.t('page.settings.purchasePrice.readOnlyNotice'),
          },
        ],
  };

  return (
    <SettingsTemplate
      header={header}
      description={i18n.t('page.settings.purchasePrice.description')}
      data-testid={testIds.settings.purchasePrice('template')}
    >
      <VStack spacing={6}>
        <SettingsSection>
          <PurchasePriceCostsForm isReadOnly={!canSetFinanceSettings} />
        </SettingsSection>

        <SettingsSection>
          <CopyRealCostsToExpectedSwitch
            data-testid={testIds.settings.purchasePrice('copyRealCostsToExpected')}
          />
        </SettingsSection>

        <PurchasePriceRules />
      </VStack>
    </SettingsTemplate>
  );
}
